var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningLine = function SvgWarningLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7H13.5V13H11.5V7Z",
    fill: "#E56C6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15H11.5V17H13.5V15Z",
    fill: "#E56C6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 2L2.5 8V16L8.5 22H16.5L22.5 16V8L16.5 2H8.5ZM4.5 8.82843V15.1716L9.32843 20H15.6716L20.5 15.1716V8.82843L15.6716 4H9.32843L4.5 8.82843Z",
    fill: "#E56C6C"
  })));
};
export default SvgWarningLine;